
import React from "react";
import { Banknote, Clock } from "lucide-react";

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Banknote className="w-12 h-12 text-drcash-caribbean-green" />,
      title: "Antecipação Simples e Rápida",
      description: "Antecipe várias maquininhas, inclusive de unidades (clínicas) diferentes em uma única operação, aproveitando uma taxa única."
    },
    {
      icon: <Banknote className="w-12 h-12 text-drcash-caribbean-green" />,
      title: "Gestão Centralizada",
      description: "Gerencie toda a sua carteira de antecipação em um único lugar, de forma prática e eficiente."
    },
    {
      icon: <Banknote className="w-12 h-12 text-drcash-caribbean-green" />,
      title: "Acesso a Múltiplos Bancos",
      description: "Consulte e escolha entre várias taxas de bancos parceiros, sem custo adicional, e escolha a que melhor se adapta às suas necessidades."
    },
    {
      icon: <Clock className="w-12 h-12 text-drcash-caribbean-green" />,
      title: "Pagamento Rápido",
      description: "Receba no mesmo dia, com pagamento em D0 para solicitações realizadas até às 15h."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1 bg-drcash-caribbean-green/10 rounded-full text-drcash-caribbean-green text-sm mb-6">
            Vantagens Exclusivas
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-6">
            Principais Benefícios da Dr.Cash para sua Clínica
          </h2>
          <p className="max-w-3xl mx-auto text-drcash-slate-gray">
            Nossa plataforma foi desenvolvida pensando nas necessidades específicas das clínicas de saúde, oferecendo soluções que realmente fazem diferença no seu dia a dia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="p-8 rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="mb-6">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-drcash-maastricht-blue mb-4">{benefit.title}</h3>
              <p className="text-drcash-slate-gray">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
